import MockAdapter from 'axios-mock-adapter';
import axiosInstance from './axiosConfig';

// This sets the mock adapter on the existing axios instance
const mock = new MockAdapter(axiosInstance, { delayResponse: 500 }); // 500ms delay to simulate real network

// --- ADD YOUR MOCK ENDPOINTS HERE ---

// Example 1: Mocking a GET request
// mock.onGet('/news').reply(200, {
//   status: 'success',
//   data: [
//     { id: 1, title: 'Mock Breaking News 1', content: 'This is mock data for design' },
//     { id: 2, title: 'Mock Breaking News 2', content: 'More mock data' }
//   ]
// });

// Example 2: Mocking a POST request (e.g. login)
// mock.onPost('/auth/login').reply(200, {
//   token: 'fake-jwt-token-12345',
//   user: { name: 'Design User' }
// });

// IMPORTANT: Allow any other un-mocked requests to pass through to the real backend
mock.onAny().passThrough();

export default mock;
